import { ArrowRight, TableCellsMerge } from "lucide-react";
import React from "react"; 

const teamMembers = [
    { name: "Bryan Knight", role: "Project Manager", position: "top-0 left-1/2 -translate-x-1/2 -translate-y-full w-[max-content]" },
    { name: "Amanda Reed", role: "Frontend Development Manager", position: "top-1/2 lg:-left-[3rem] md:-left-[3rem] sm:-left-[14rem] -left-[14rem] translate-x-full -translate-y-1/2" },
    { name: "Joan Wallace", role: "COO", position: "bottom-[20rem] left-[5rem] -translate-x-full translate-y-1/2" },
    { name: "Carolyn Ortiz", role: "Android Developer", position: "bottom-0 right-1/4 translate-x-1/2 translate-y-full" },
    { name: "Julia Manchuk", role: "Business Development", position: "bottom-[3rem] left-1 -translate-x-1/2 translate-y-full" },
];

const TalkWithUs = () => {
 
    return (
        <div className="bg-[#fff] p-6 md:p-20">
            <div className="max-w-7xl mx-auto p-6">
                <div className="grid lg:grid-cols-2 gap-12 items-center">
                    <div className="relative">
                        <div className="relative w-full aspect-square max-w-md mx-auto">
                            <div className="absolute inset-0 rounded-full bg-[#ffedfd]">
                                <img src={require('../../assets/image/RKR_FULL-svg.png')} alt="Team member" className="w-full h-full object-contain rounded-full" />
                            </div>

                            {teamMembers.map((member, index) => (
                                <div key={index} className={`absolute bg-[#ffedfc] p-2 rounded-lg lg:block md:block sm:hidden hidden ${member.position}`}>
                                     <div className="flex items-center gap-2">
                                        <div className="">
                                            <img src={require('../../assets/image/user-avatar-icon.png')} alt="Team member" className="w-11 h-11 bg-[#fff] object-contain rounded-full" />
                                        </div>
                                        <div className="">
                                            <h5 className="text-[#6540b2] text-lg font-[500]">{member.name}</h5>
                                            <h5 className="text-slate-700 text-sm font-[500]">{member.role}</h5>
                                        </div>
                                     </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="lg:max-w-xl">
                        
                        <h1 className="text-4xl md:text-5xl font-bold mb-4 text-[#6540b2]">Talk with us</h1>
                        <p className="text-lg text-slate-700 mb-12">Whether you're just gathering info or you're ready to start talking specifics, we're happy to discuss any questions you have.</p>

                        <div>
                            <form className="space-y-6">
                                <div className="grid md:grid-cols-2 gap-2">
                                    <div>
                                        <label className="text-[#6540b2]">Name*</label>
                                        <div>
                                            <input placeholder="Full name*" type="text" className="bg-[#ffedfd] text-[#6540b2] px-3 h-[48px] w-[100%] outline-none focus:outline-none rounded-lg border border-[#ffdbf9]" />
                                        </div> 
                                    </div>
                                    <div>
                                        <label className="text-[#6540b2]">Company*</label>
                                        <div>
                                            <input placeholder="Company name*" type="text" className="bg-[#ffedfd] text-[#6540b2] px-3 h-[48px] w-[100%] outline-none focus:outline-none rounded-lg border border-[#ffdbf9]" />
                                        </div> 
                                    </div>
                                     
                                </div>
                                <div className="grid md:grid-cols-2 gap-2">
                                    <div>
                                        <label className="text-[#6540b2]">Email ID*</label>
                                        <div>
                                            <input placeholder="Email ID*" type="email" className="bg-[#ffedfd] text-[#6540b2] px-3 h-[48px] w-[100%] outline-none focus:outline-none rounded-lg border border-[#ffdbf9]" />
                                        </div> 
                                    </div>
                                    <div>
                                        <label className="text-[#6540b2]">Country*</label>
                                        <div>
                                            <input placeholder="Country name*" type="text" className="bg-[#ffedfd] text-[#6540b2] px-3 h-[48px] w-[100%] outline-none focus:outline-none rounded-lg border border-[#ffdbf9]" />
                                        </div> 
                                    </div>
                                     
                                </div>
                                <div className="">
                                    <div className="mb-3">
                                        <label className="text-[#6540b2]">Phone*</label>
                                        <div>
                                            <input placeholder="Phone*" type="number" className="bg-[#ffedfd] text-[#6540b2] px-3 h-[48px] w-[100%] outline-none focus:outline-none rounded-lg border border-[#ffdbf9]" />
                                        </div> 
                                    </div> 
                                    <div>
                                        <label className="text-[#6540b2]">Message*</label>
                                        <div>
                                            <textarea placeholder="How can we help?*" rows={3} className="bg-[#ffedfd] text-[#6540b2] p-3 w-[100%] outline-none focus:outline-none rounded-lg border border-[#ffdbf9]" />
                                        </div> 
                                    </div>   
                                </div>
 
                                <div className="text-sm text-gray-400">
                                    By sending this form you agree that NEKLO will process your personal information in accordance with our 
                                    <a href="#" className="underline">Privacy Policy</a>and <a href="#" className="underline">Terms of Use</a> 
                                </div>

                                <div className="containerBtn">
                                    <button size="lg" className="btn px-8 h-14 rounded-full text-lg flex items-center gap-1">
                                        <span> Submit <ArrowRight className="ml-2 h-5 w-5" /></span>
                                    </button> 
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TalkWithUs;
